import { api } from "..";

export const getFundObligationsPaymentDetails = async (token, obligationId) => {
  try {
    const { data } = await api({
      url: `/api/v1/admin/shareObligations/${obligationId}/payout`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return {
      data,
    };
  } catch (error) {
    return {
      error,
    };
  }
};
